import Utils from "./_utils";

const Slideshow = {

	build: false,

	elements: {},

	totalSlides: 0,

	currentSlide: 0,

	slideshowInstance: null,

	activeSlideClass: 'slideshow__dot--active',

	lastSlide: null,

	minViewportRatio: 2.13,
	maxViewportRatio: 2.4,

	setLastSlide(currentSlide)
	{
		this.lastSlide = currentSlide;
	},

	startNextVideo(nextSlide)
	{
		const video = nextSlide.querySelector('video');
		if (video) {
			video.currentTime = 0;
			video.play();
		}
	},

	pauseLastVideo()
	{
		if (this.lastSlide) {
			const video = this.lastSlide.querySelector('video');
			if (video) {
				video.pause();
				video.currentTime = 0;
			}
		}
	},

	getSlideVideo()
	{
		const index = this.slideshowInstance[0].slick.currentSlide;
		const currentSlide = this.elements.slides[index];
		return currentSlide.querySelector('video');
	},

	getSlideSpace(minHeight = 480)
	{
		const mastheadHeight = this.elements.masthead.offsetHeight;
		let extraOffset = 0;
		if (this.elements.extraOffsetFactors) {
			Array.prototype.forEach.call(this.elements.extraOffsetFactors, (element) =>
			{
				extraOffset += element.offsetHeight;
			});
		}
		const calculatedHeight = window.innerHeight - (mastheadHeight + extraOffset);
		return Math.max(calculatedHeight, minHeight);
	},

	getSlideshowMinHeight() {

		// if( window.matchMedia('(min-width: 681px').matches ) {
		// 	return 'auto'
		// }

		let imageHeight = 0;
		let captionHeight = 0;

		const images = this.elements.slideshow.querySelectorAll('.banner__image')
		const captions = this.elements.slideshow.querySelectorAll('.banner__tag') // not really a caption, at this point we're hiding H2 and we only show the tag which is the "project title"

		if( images ) {
			imageHeight = this.getTallest(Array.from(images))
		}

		if( captions ) {
			captionHeight = this.getTallest(Array.from(captions))
		}

		this.elements.slideshow.style.setProperty('--js-image-height', `${imageHeight}px`)
		this.elements.slideshow.style.setProperty('--js-caption-height', `${captionHeight}px`)

		return window.matchMedia('(min-width: 681px').matches 
			? `${imageHeight}px`
			: `${imageHeight + captionHeight}px`
	},

	getTallest(elements) {
		let tallest = 0
		elements.forEach(element => {
			element.classList.add('is-measuring')
			const { height } = element.getBoundingClientRect()
			tallest = Math.max(height, tallest)
			element.classList.remove('is-measuring')
		})
		return tallest
	},

	// will get overridden when the correct resize implementation is determined
	manageSlideAspectRatio () {
	},

	getImageAspectRatio(image)
	{
		// try to read the server-provided dimensions of the image to calculate an aspect ratio
		let imageRatio = image.getAttribute('data-width') / image.getAttribute('data-height');

		// if that didn't work, assume the image conforms to the expected image dimensions in WP
		if( isNaN(imageRatio) )
		{
			imageRatio = 2880 / 1350;
		}

		if( image.nodeName === 'VIDEO')
		{
			imageRatio = 1920 / 1080;
		}
		return imageRatio;
	},

	resizeRetainHeight()
	{
		const slideshow = this.elements.slideshow.querySelector('.js-slideshow')
		// if( ! slideshow || ! ( slideshow && !slideshow.classList.contains('media-loaded')) ) {
		if( ! slideshow ) {
			return;
		}

		const windowWidth = window.innerWidth;
		const slides = this.elements.slideshow.querySelectorAll('.js-slide');

		this.elements.slideshow.style.height = 'auto'
		const slideshowHeight = this.getSlideshowMinHeight()
		this.elements.slideshow.style.height = slideshowHeight
		
		let maxHeight = this.getSlideSpace();
		let minHeight = 0;

		if(windowWidth / maxHeight > this.maxViewportRatio)
		{
			minHeight = windowWidth / this.maxViewportRatio;
		}

		if( minHeight > maxHeight )
		{
			maxHeight = minHeight;
		}

		Array.prototype.forEach.call(slides, (element) => {
			const image = element.querySelector('img, video');
			const slide = image.parentNode;

			slide.style.height = 'auto'

			let marginTop = 0;

			if( image )
			{
				const imageRatio = this.getImageAspectRatio(image);

				const calculatedImageHeight = Math.ceil(windowWidth / imageRatio);

				if( calculatedImageHeight > maxHeight )
				{
					marginTop = - ((calculatedImageHeight - maxHeight) / 2);
				}
				
				// Reset any previous styles applied (possibly from resizeFill running at mobile)
				image.style = '';
				slide.style = '';

				slide.style.overflow = 'hidden';
				slide.style.minHeight = minHeight + 'px';
				slide.style.maxHeight = maxHeight + 'px';
				image.style.marginTop = marginTop + 'px';
			}
		});
	},

	resizeFill()
	{
		const windowWidth = window.innerWidth;
		const slideHeight = this.getSlideSpace();
		const viewportRatio = windowWidth / slideHeight;
		const slides = this.elements.slideshow.querySelectorAll('.js-slide');

		// set the height of the slideshow because it's gaining a px somehow
		this.elements.slideshow.style.height = slideHeight + 'px';

		Array.prototype.forEach.call(slides, (element) => {

			const image = element.querySelector('img, video');
			const slide = image.parentNode;

			if( image )
			{
				// try to read the server-provided dimensions of the image to calculate an aspect ratio
				const imageRatio = this.getImageAspectRatio(image);

				// defaults
				let marginTop = 0;
				let marginLeft = 0;

				let calculatedImageHeight = windowWidth / imageRatio;
				let calculatedImageWidth = slideHeight * imageRatio;

				if (viewportRatio > imageRatio) {
					calculatedImageWidth = windowWidth;
					calculatedImageHeight = windowWidth / imageRatio;

					marginTop = -( (calculatedImageHeight - slideHeight) / 2 );

					if (calculatedImageHeight < slideHeight) {
						calculatedImageHeight = slideHeight;
						calculatedImageWidth = slideHeight * imageRatio;

						marginLeft = -( (calculatedImageWidth - windowWidth) / 2 );
					}
				}
				else {
					calculatedImageHeight = slideHeight;
					calculatedImageWidth = slideHeight * imageRatio;

					marginLeft = -( (calculatedImageWidth - windowWidth) / 2 );
				}

				// Reset any previous styles applied (possibly from resizeFill running at mobile)
				slide.style = '';
				image.style = '';

				slide.style.height = slideHeight + 'px';

				image.style.transform = `translate(${marginLeft}px, ${marginTop}px`;
				image.style.width = calculatedImageWidth + 'px';
				image.style.height = calculatedImageHeight + 'px';
			}
		});
	},

	bind()
	{
		// only render a slideshow if there's more than a single slide
		// we'll still manage the aspect ratio of the slide, if not
		if(this.build)
		{
			var self = this;
			this.slideshowInstance = $('.js-slideshow');

			// Responded to a video/img load event and add a class to the slideshow to transition scaling away
			// from CSS and into JS hands
			this.slideshowInstance.find('.banner__image img').on('load', () => {
				this.slideshowInstance.addClass('media-loaded')
				this.handleResize()
			})
			
			var $videos = this.slideshowInstance.find('.banner__image video')
			if( $videos.length ) {
				$videos.each(function(){
					var video = this;
					video.addEventListener('loadeddata', () => {
						if( self.slideshowInstance ) {
							self.slideshowInstance.addClass('media-loaded')
						}
						self.handleResize()
					})
				})
			}
			
			this.slideshowInstance.find('.banner__image video').on('loadeddata', () => {
				
				this.slideshowInstance.addClass('media-loaded')
				this.handleResize()
			})
			this.slideshowInstance.find('.banner__image video').on('loadloadeddata', () => {
				this.slideshowInstance.addClass('media-loaded')
				this.handleResize()
			})

			setTimeout(() => {
				this.slideshowInstance.addClass('media-loaded')
			}, 2000)

			this.slideshowInstance.on('init', (event, slick) => {
				setTimeout( () => {
					this.startNextVideo(slick.$slides.get(0));
				}, 500);
			});

			this.slideshowInstance.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
				this.setLastSlide(slick.$slides.get(currentSlide));
				this.startNextVideo(slick.$slides.get(nextSlide));
			});

			this.slideshowInstance.on('afterChange', (event, slick, currentSlide) => {
				this.pauseLastVideo();
			});

			this.slideshowInstance.slick({
				'slide': '.js-slide',

				'arrows': true,
				'prevArrow': $('.js-prev-slide'),
				'nextArrow': $('.js-next-slide'),

				'dots': true,
				'appendDots': $('.js-slideshow-dots'),

				'fade': true,
				'swipeToSlide': true,
				'touchMove': true,

				'infinite': true,
				'autoplay': true,
				'autoplaySpeed': 8000,
				'pauseOnHover': false,

				customPaging : function(slider, i) {
					return '<div class="slideshow__dot"></div>';
				}
			});

			window.addEventListener('onLightboxOpen', e => {
				this.slideshowInstance.slick('slickPause');
			});

			window.addEventListener('onLightboxClose', e => {
				setTimeout( () => {
					this.slideshowInstance.slick('slickPlay');
				}, 100);
			});
		}

		// overwrite
		this.manageSlideAspectRatio = ( document.querySelector('.js-resize-retain-full-image'))
			? this.resizeRetainHeight
			: this.resizeFill;

		
		// Slide shows on /people landings (or elsewhere as defined on relevant slideshows) will not be
		// scaled by JS. Instead, they'll have min & max heights defined in css

		if( this.elements.slideshow ) {

			this.handleResize()
			// resizeHandler()
			// this.manageSlideAspectRatio();

			const self = this

			function resizeHandler() {
				self.handleResize()
			}

			const debouncedResize = Utils.debounce(resizeHandler, 250)

			window.addEventListener('resize', debouncedResize);
		}

		if( this.elements.linkedBanners ) {
			Object.keys(this.elements.linkedBanners).forEach( function(key) {
				const banner = this.elements.linkedBanners[key] 
				const link = banner.querySelector('a')

				if( !link ) return
				
				banner.addEventListener('click', () => {
					if( window.matchMedia('(min-width: 681px)').matches ) return

					link.click()
				})
			}.bind(this))
		}
	},

	handleResize() {

		// This is a temporary solution for staging the affect of transitioning to mobile, for client review
		this.manageSlideAspectRatio()

		// The following will toggle between fill/scale once we get to mobile
		// const desktop = window.matchMedia('(min-width: 681px)').matches
		// if( !desktop ) {
		// 	this.resizeFill()
		// 	return
		// }

		// this.noCropOnScale
		// 	? this.resizeRetainHeight()
		// 	: this.resizeFill()
	},

	cacheDom()
	{
		this.noCropOnScale = document.querySelector('.js-resize-retain-full-image')
		const slideshow = document.querySelector('.slideshow');
		this.elements.masthead = document.querySelector('.js-masthead');
		this.elements.extraOffsetFactors = document.querySelectorAll('.js-slide-offset-factor');
		this.elements.slideshow = slideshow;

		if( slideshow )
		{
			this.minViewportRatio = slideshow.getAttribute('data-viewport-min-ratio') || 2.13;
			this.maxViewportRatio = slideshow.getAttribute('data-viewport-max-ratio') || 2.4;

			this.elements.slides = slideshow.querySelectorAll('.js-slide');
			this.totalSlides = this.elements.slides.length;

			if( this.totalSlides > 1)
			{
				this.build = true;
			}

			this.elements.linkedBanners = this.elements.slideshow.querySelectorAll('.has-link')
		}
	},

	init()
	{
		this.cacheDom();
		this.bind();
	}

};

export default Slideshow;